<template>
  <div class="input-container" :class="{ 'required-fail': requiredFail }">
    <input
      :value="value"
      @input="updateValue($event.target.value)"
      @keypress="
        restrictSpecialCharacters
          ? nameKeydown($event)
          : $emit('check-alphanumeric', $event)"
      type="text"
      :disabled="disabled"
      :placeholder="placeholder"
      :class="{
        'with-label-button': automaticLabel
      }"
      :id="fieldId"
    />

      
  </div>
</template>

<script>
import { inputTypeMixin } from "@/mixins/forms/dynamicObjectForms/inputTypeMixin";


export default {
  name: "InputTypeTextNPV",

  mixins: [inputTypeMixin],

  props: {
    automaticLabel: {
      type: Boolean,
      default: false
    },
    restrictSpecialCharacters: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    //does a Regex check to stop the the input of certain special characters €,_,| etc
    nameKeydown(e) {
      if (!e.key.match(/^[a-zA-Z0-9]*$/)) {
        e.preventDefault();
      }
    }
  }
};
</script>

<style scoped>
input.with-label-button {
  width: 80%;
}

.automatic-label-svg {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Npv/Configuration/components/InputTypesNPV/InputTypeTextNPV.vue